<template>
  <div class="app-footer">
    <v-container class="footer-container d-flex flex-column justify-center">
      <div
        class="d-flex flex-column flex-md-row justify-md-space-between text-6"
      >
        <div class="d-flex flex-column flex-md-row align-center">
          <a
            href="https://akash.network"
            target="_blank"
            rel="noopener noreferrer"
            class="d-flex align-center"
          >
            <img
              v-if="$vuetify.theme.dark"
              src="@/assets/img/powered-by-akash-dark.svg"
              height="18px"
              alt="powered by akash"
              class="mr-0 mr-md-8 mb-4 mb-md-0"
            />
            <img
              v-else
              src="@/assets/img/powered-by-akash.svg"
              height="18px"
              alt="powered by akash"
              class="mr-0 mr-md-8 mb-4 mb-md-0"
            />
          </a>
          <div class="d-flex align-center gray--text">
            <v-icon x-small class="gray--text">far fa-copyright</v-icon>
            <span class="ml-2">{{ new Date() | datetime("yyyy") }}</span>
            <a
              href="https://unagii.com"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none ml-1 mr-1"
              >Unagii</a
            >
            <span>by</span>
            <a
              href="https://stakewith.us"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none ml-1"
              >Stakewithus Pte Ltd</a
            >
          </div>
        </div>

        <div
          class="d-flex flex-column flex-md-row align-md-center mt-5 mt-md-0"
        >
          <div class="d-flex flex-column align-between flex-md-row">
            <div class="d-flex">
              <a
                href="https://docs.unagii.com"
                target="_blank"
                rel="noopener noreferrer"
                class="gray--text text-decoration-none"
                >Docs</a
              >
            </div>
            <div class="d-flex mt-3 mt-md-0">
              <a
                href="mailto:support@unagii.com"
                class="gray--text text-decoration-none ml-md-5"
                >Contact Support</a
              >
              <a
                href="https://www.unagii.com/legal/terms"
                target="_blank"
                rel="noopener noreferrer"
                class="gray--text text-decoration-none ml-5"
                >Terms</a
              >
              <a
                href="https://www.unagii.com/legal/privacy"
                target="_blank"
                rel="noopener noreferrer"
                class="gray--text text-decoration-none ml-5"
                >Privacy</a
              >
            </div>
          </div>
          <div class="d-flex align-center justify-space-between mt-5 mt-md-0">
            <v-divider vertical class="ml-8 mr-8 d-none d-md-block"></v-divider>
            <div class="social-links d-flex align-center">
              <a
                href="https://twitter.com/unagiidotcom"
                class="line-height-0 text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
              >
                <v-icon small class="gray--text">fab fa-twitter</v-icon>
              </a>
              <a
                href="https://t.me/unagiidotcom"
                class="line-height-0 ml-5 text-decoration-none"
              >
                <v-icon small class="gray--text">fab fa-telegram-plane</v-icon>
              </a>
              <a
                href="https://reddit.com/r/unagiidotcom"
                class="line-height-0 ml-5 text-decoration-none"
              >
                <v-icon small class="gray--text">fab fa-reddit-alien</v-icon>
              </a>
            </div>
            <v-divider vertical class="ml-8 mr-8 d-none d-md-block"></v-divider>
            <v-tooltip top color="dark">
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="clickable"
                  @click="switchTheme"
                >
                  <v-icon small class="gray--text" v-if="$vuetify.theme.dark"
                    >fa-moon</v-icon
                  >
                  <v-icon small class="gray--text" v-else>fa-sun</v-icon>
                </div>
              </template>
              <span v-if="$vuetify.theme.dark">Switch to Light Mode</span>
              <span v-else>Switch to Dark Mode</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  methods: {
    switchTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
};
</script>

<style lang="scss">
// .theme--light {
//   .app-footer {
//     background-color: #f4f4f5;
//   }
// }
.theme--dark {
  .app-footer {
    background-color: #222e3b;
  }
}

.footer-container {
  @media (min-width: 960px) {
    height: 80px;
  }
}
</style>
